import Tests from "../pages/TestPages/Tests";
import NotFound from "../pages/DefaultPages/NotFound/NotFound";
import NotAuthorized from "../pages/DefaultPages/NotAuthorized/NotAuthorized";
import Home from "../pages/DefaultPages/Home/Home";
import ValidationTests from "../pages/TestPages/ValidationTests";
import DargahpardakhtSaman from "../pages/TestPages/DargahpardakhtSaman/DargahpardakhtSaman";
import CheckPayment from "../pages/TestPages/DargahpardakhtSaman/CheckPayment/CheckPayment";

const defaultRoutes = [
  {
    id: "asgxccv46",
    path: "/",
    element: <Home />,
  },
  {
    id: "alsgas45a6sfg",
    path: "/tests",
    element: <Tests />,
  },
  // {
  //   id: "a4lsgas454a6sfg",
  //   path: "/teste-dargah-pardakht-saman",
  //   element: <DargahpardakhtSaman />,
  // },
  // {
  //   id: "a4ls46sfg",
  //   path: "/teste-dargah-pardakht-saman/check-payment/Payment",
  //   element: <CheckPayment />,
  // },
  {
    id: "asgxcxcv46",
    path: "/validation-tests",
    element: <ValidationTests />,
  },
  // {
  //   id: "alsgas45a6sfg",
  //   path: "/login-test",
  //   element: <Login />,
  // },
  {
    id: "asgxcvwcv46",
    path: "/not-authorized",
    element: <NotAuthorized />,
  },
  {
    id: "alsgq2as45a6sfg",
    path: "*",
    element: <NotFound />,
  },
];

export default defaultRoutes;
